import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import React, { useEffect } from 'react';

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const cleanPercentage = (percentage) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
    const isTooHigh = percentage > 100;
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
  };

const Circle = ({ colour, percentage, className, id }) => {
        const r = 50; // Reduced radius to make the circle smaller
        const circ = 2 * Math.PI * r;
        const strokePct = ((100 - percentage) * circ) / 100;
    
        // Calculate the CSS variable value for --fill-percentage
        const fillPercentageStyle = {
                '--fill-percentage': `${strokePct}px`
        };

        return (
            <circle
                id={id}
                r={r}
                cx="100"
                cy="100"
                fill="transparent"
                stroke={strokePct !== circ ? colour : ""}
                strokeWidth={"1.2rem"}
                strokeDasharray={circ}
                strokeDashoffset={circ} // Start with full circumference
                className={`animatedColor ${className}`}
                strokeLinecap="round"
                style={fillPercentageStyle} // Apply the CSS variable for animation
            ></circle>
        );
};

  const Text = ({ percentage, colour }) => {
    return (
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="1.2em"
        fontFamily="'Centra', sans-serif"
        fontWeight="bold"
        fill={colour} // Apply the color here
      >
        {percentage.toFixed(0)}%
      </text>
    );
  };
  
  const Text2 = ({ prompt, colour }) => {
    return (
      <text
        x="50%"
        // Adjusted y position for better separation from the percentage text
        y="93%" // Adjust this value as needed to position the prompt text appropriately
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="1em"
        fontFamily="'Centra', sans-serif"
        fontWeight="bold"
        fill={colour}
      >
        {prompt}
      </text>
    );
}

  const Pie = ({ percentage, colour, prompt, className}) => {
      const pct = cleanPercentage(percentage);
      // Adjust the SVG size
      const svgSize = 150; // Smaller size
      const scale = svgSize / 200; // Calculate scale based on new size
  
      return (
        <svg width={svgSize} height={svgSize}>
          <g transform={`rotate(-90 ${svgSize / 2} ${svgSize / 2}) scale(${scale})`}>
            <Circle colour={colour} percentage={pct} className={className}/>
          </g>
          <Text percentage={pct} colour={colour} />
          <Text2 prompt={prompt} colour={colour} />
        </svg>
      );
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn" style={{ border: '10px solid #EAD1DA'}}>
              <h2 style={{ color: '#D6E0D2', marginBottom: '30px' }}>My Skills</h2>

              <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider" >
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={85} colour="#D6E0D2" prompt={"Angular"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={85} colour="#D6E0D2" prompt={"NodeJS"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={70} colour="#D6E0D2" prompt={"Java"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={55} colour="#D6E0D2" prompt={".NET"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={75} colour="#D6E0D2" prompt={"React"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={80} colour="#D6E0D2" prompt={"SQL"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={100} colour="#D6E0D2" prompt={"Notion"} className="animatedColor" />
                </div>
                <div style={{ color: 'white' }} className="item">
                  <Pie percentage={40} colour="#D6E0D2" prompt={"Unity"} className="animatedColor" />
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
